import React from 'react';
import { Tabs, TabHeader, TabPanel } from '@wk/components-react16';
import AddUser from './AddUser';
import EditUser from './EditUser';
import { logUserActivity, UserActivity } from '../../services';

const UserManagement = ({ roleList }: any) => {
    const handleActivity = (event: any) => {
        let userActivity: UserActivity = {
            action: 'Tab Click',
            page: 'User Management',
            viewName: event == 0 ? 'Add User' : 'Edit User',
        }
        logUserActivity(userActivity);
    }

    return (
        <div>
            <Tabs mode="default" onUserRequest={(event: any) => handleActivity(event)}>
                <TabHeader slot="tabHeader">Add User</TabHeader>
                <TabHeader slot="tabHeader">Edit User</TabHeader>
                <TabPanel slot="tabPanel">
                    <AddUser roleList={roleList} />
                </TabPanel>
                <TabPanel slot="tabPanel">
                    <EditUser roleList={roleList} />
                </TabPanel>
            </Tabs >
        </div >
    );
};

export default UserManagement
